import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { social_getPostById } from '../../../store/actionsv1/social';
import { PostProps } from '../../../store/types/soc_svc';
import PostCard from './PostCard';

type SharedPostHolderProps = {
    navigation:any,
    view_mode: 'edit'|'view'
    post_id:string,
    onRemovePost?:(post_id:string) => void
}
const SharedPostHolder = ({ navigation, post_id, view_mode, onRemovePost }:SharedPostHolderProps) => {
    const [ loading, setLoading ] = useState(false);
    const dispatch = useDispatch();
    const post:PostProps | undefined = useSelector((state:any) => state.social.stored_posts.find((p:PostProps) => p.memo_post_id == post_id), (left, right) => { 
        if(post_id && left?.memo_post_id != right?.memo_post_id){ return false }
        return true
    })

    useEffect(() => {
        if(post){ return }
        getPostFromServer()
    },[])

    const handleRemovePost = (post_id:string) => {
        if(!onRemovePost){ return }
        return onRemovePost(post_id)
    }

    const getPostFromServer = async() => {
        setLoading(true)
        await dispatch(social_getPostById(post_id, true))
        setLoading(false)
    }

    if(!post){ return <></> }
    return (
        <TouchableOpacity onPress={() => navigation.push('ActivityDetail', { post_id: post_id, post_type: 'memo' })}>
            <PostCard navigation={navigation} view_type='shared' post={post}/>
            {view_mode === 'edit' ?
            <TouchableOpacity style={{ position:'absolute', justifyContent:'center', alignItems:'center', borderRadius:100, top:5, right:5, width:20, height:20, backgroundColor:Colors.shades.white }} onPress={() => handleRemovePost(post_id)}>
                <Icon name='x' type='feather' color={Colors.brand.slate} size={16}/>
            </TouchableOpacity>
            :<></>}
        </TouchableOpacity>
    )
}

export default SharedPostHolder